import React, { useEffect, useState } from "react";
import { ArrowClockwise, DotOutline } from "@phosphor-icons/react";

/**
 * Small "Live · updated Xs ago" chip used on customer ledger + dashboard
 * to visually signal that numbers are auto-refreshing. Includes a manual
 * refresh button so users can pull down the latest instantly.
 */
export default function LastUpdatedChip({ lastUpdated, isRefreshing, onRefresh, testId = "last-updated" }) {
    const [tick, setTick] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setTick((t) => t + 1), 5000);
        return () => clearInterval(id);
    }, []);

    const relative = (() => {
        if (!lastUpdated) return "";
        const s = Math.max(0, Math.floor((Date.now() - lastUpdated.getTime()) / 1000));
        if (s < 5) return "just now";
        if (s < 60) return `${s}s ago`;
        const m = Math.floor(s / 60);
        if (m < 60) return `${m}m ago`;
        const h = Math.floor(m / 60);
        return `${h}h ago`;
    })();
    void tick; // keep dep for re-render

    return (
        <div className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-800" data-testid={testId}>
            <DotOutline size={14} weight="fill" className={`text-emerald-500 ${isRefreshing ? "animate-pulse" : ""}`} />
            <span data-testid={`${testId}-time`}>Live · updated {relative}</span>
            {onRefresh && (
                <button
                    type="button"
                    onClick={onRefresh}
                    disabled={isRefreshing}
                    data-testid={`${testId}-refresh`}
                    className="rounded-full p-0.5 text-emerald-700 hover:bg-emerald-100 disabled:opacity-50"
                    title="Refresh now"
                >
                    <ArrowClockwise size={11} weight="bold" className={isRefreshing ? "animate-spin" : ""} />
                </button>
            )}
        </div>
    );
}
